import { HeaterSelectionAssistant } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";
import type ComponentTypes from "~/features/cms/componentTypes";

/**
 * CMS wrapper for the {@code SchaefflerHeaterSelectionAssistantComponent}.
 *
 * <p>The BFF transformer ({@code SchaefflerHeaterSelectionAssistantComponentTransformer}) emits
 * only the component {@code uid} as {@code componentId}; the {@link HeaterSelectionAssistant} island
 * fetches its own data client-side, mirroring the pre-shell JSP behavior where it mounted proplessly
 * via {@code createComponentAtId('HeaterSelectionAssistant', ...)}. The config blob is therefore
 * intentionally ignored here; the island owns its data and rendering.
 */
export interface CMSHeaterSelectionAssistantProps {
  type: ComponentTypes.CMSHeaterSelectionAssistant;
  id?: string;
  className?: string;
}

export const CMSHeaterSelectionAssistant = (_props: CMSHeaterSelectionAssistantProps) => {
  return <HeaterSelectionAssistant />;
};
